<script setup>
const emit = defineEmits(['select']);
// NOTICE: KAPTION-INTEGRATION - ReactionPicker for selecting emoji reactions
const emojis = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
const handleSelect = emoji => {
  emit('select', emoji);
};
</script>

<template>
  <div
    class="reaction-picker-wrapper flex gap-1 p-1 bg-n-alpha-3 rounded-md shadow-sm"
  >
    <button
      v-for="emoji in emojis"
      :key="emoji"
      class="emoji-btn hover:bg-n-alpha-2 p-1.5 rounded text-lg leading-none transition-colors border-none bg-transparent"
      type="button"
      @click.prevent.stop="handleSelect(emoji)"
      @touchend.stop.prevent="() => handleSelect(emoji)"
    >
      {{ emoji }}
    </button>
  </div>
</template>

<style scoped>
.reaction-picker-wrapper {
  pointer-events: auto;
  position: relative;
  z-index: 1000;
}

.emoji-btn {
  pointer-events: auto;
  cursor: pointer;
  padding: 8px 12px;
}
</style>
